export function createExcalidrawNode(view, data = "[]", width = null, height = null) {
    const schema = view.state.schema;
    return schema.nodes.excalidraw.create({
        data,
        width,
        height,
        createdAt: new Date().getTime().toString(),
    });
}
export function handleExcalidrawDropEvent(event, view) {
    // current selection
    const { from, to } = view.state.selection;
    // selected content
    const selectedContent = view.state.doc.slice(from, to);
    const excalidrawNodes = [];
    selectedContent.content.nodesBetween(0, selectedContent.size, (node) => {
        if (node.type.name === "excalidraw") {
            excalidrawNodes.push(node);
        }
    });
    if (excalidrawNodes.length) {
        const pos = view.posAtCoords({ left: event.clientX, top: event.clientY });
        if (!pos) {
            return false;
        }
        const tr = view.state.tr;
        tr.delete(from, to);
        const [excalidrawNode] = excalidrawNodes;
        tr.insert(pos.pos, excalidrawNode);
        view.dispatch(tr);
        event.preventDefault();
        event.stopPropagation();
        return true;
    }
    return false;
}
